function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_USER = '/user';
const ROOTS_HOME = '';

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact:
    'https://makewebbetter.com/contact-us/?utm_source=app&utm_medium=mwb&utm_campaign=formpay',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verifyEmail: path(ROOTS_AUTH, '/verify-email'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  changePassword: path(ROOTS_AUTH, '/change-password'),
  resendEmail: path(ROOTS_AUTH, '/resend-mail'),
};
export const PATH_USER = {
  root: ROOTS_USER,
  portals: path(ROOTS_USER, '/portals'),
  portalalreadyconnected: path(ROOTS_USER, '/error/portal-already-connected'),
  forgotReset: path(ROOTS_USER, '/forgotreset'),
  profile: path(ROOTS_USER, '/profile'),
  general: {
    accountSettings: (portalId: string, tab: string) =>
      // eslint-disable-next-line no-useless-concat
      '/' + portalId + path(ROOTS_USER, '/settings' + '/' + tab),
  },
  payments: {
    payments: (portalId: string) =>
      '/' + portalId + path(ROOTS_USER, '/payments'),
  },
  connectToHubspot: path(ROOTS_USER, '/connect-to-hubspot'),
};

export const ROOT_NAVIGATION = {
  root: ROOTS_HOME,
  general: {
    home: (portalId: string) => '/' + portalId + path(ROOTS_HOME, '/app'),
    forms: (portalId: string) => '/' + portalId + '/forms/list',
    products: (portalId: string) => '/' + portalId + '/products',
    productCreate: (portalId: string) => '/' + portalId + '/products/create',
    coupons: (portalId: string) => '/' + portalId + '/coupons',
    couponsCreate: (portalId: string) => '/' + portalId + '/coupons/create',
    couponEdit: (portalId: string, id: string) =>
      '/' + portalId + '/coupons/edit/' + id,
    productEdit: (portalId: string, id: string) =>
      '/' + portalId + '/products/edit/' + id,

    quotes: (portalId: string) => '/' + portalId + '/quotes/list',
    quotesEdit: (portalId: string, quoteId: string) =>
      '/' + portalId + '/quotes/edit/' + quoteId,
    formSubmission: (portalId: string) =>
      '/' + portalId + '/formsubmission/list',
    transactions: (portalId: string) => '/' + portalId + '/transactions',
    transactionlisting: (portalId: string) =>
      '/' + portalId + '/transactions/transactionlisting',
    subscriptionlisting: (portalId: string) =>
      '/' + portalId + '/transactions/subscriptionlisting',
    gateways: (portalId: string) =>
      '/' + portalId + path(ROOTS_HOME, '/gateways'),
    gatewayList: (portalId: string) => '/' + portalId + '/gateways',
    gatewayEdit: (portalId: string, gatewayId: string) =>
      '/' + portalId + path(ROOTS_HOME, '/gateways/edit/' + gatewayId),
    formEdit: (portalId: string, formId: string) =>
      '/' + portalId + path(ROOTS_HOME, '/forms/edit/' + formId),
  },
};

export const SUPPORT_URL =
  'https://makewebbetter.com/contact-us/?utm_source=app&utm_medium=mwb&utm_campaign=formpay';

export const TERMS_AND_CONDITIONS_URL =
  'https://makewebbetter.com/terms-and-conditions/';

export const PRIVACY_POLICY_URL = 'https://makewebbetter.com/privacy-policy/';

export const SCHEDULE_NOW_MEETING_URL =
  'https://meetings.hubspot.com/makewebbetter/free-hubspot-consultation?utm_source=app&utm_medium=mwb&utm_campaign=formpay/';

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';

export const TUTORIAL_URL =
  'https://docs.makewebbetter.com/formpay-hubspot-integration/?utm_source=app&utm_medium=mwb&utm_campaign=formpay';

export const MANAGE_HUBSPOT_URL = (portalId: string) =>
  'https://app.hubspot.com/forms/' + portalId;
